<div class="container">
  <div class="row no-gutters">
    <div class="col-12">


      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>{{ condition ? 'lblEditCheckList' : 'lblAddCheckList'}}</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>

      <form [formGroup]="addCheckListForm" (ngSubmit)="onSubmit()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-4 af-form-group">
                  <label translate>lblBrand <strong class="mlt6 required"> * </strong></label>
                  <div class='lbl-info'>
                    <ng-select class="" formControlName="brandId" 
                      placeholder="{{ 'lblSelectBrand' | translate }}">
                      <option selected [ngValue]="null" translate>lblAllBrand</option>
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblBrand</span>
                      </ng-template>

                      <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                        <span class="w-66px">{{brand.brandCode}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{brand.brandName}}</span>
                      </ng-option>
                    </ng-select>
                    <div *ngIf="cpf.brandId.touched && cpf.brandId.errors?.required" class="help-block text-danger">
                      <em class="fa fa-exclamation-circle" aria-hidden="true"></em><span
                        translate>lblPleaseSelectBrand</span>
                    </div>
                  </div>
                </div>

                <div class="col-4 af-form-group">
                  <label translate>lblVehicleType <strong class="mlt6 required"> * </strong></label>
                  <div class='lbl-info'>
                    <ng-select formControlName="vehicleTypeId" placeholder="{{ 'lblVehicleType' | translate }}"
                      [(ngModel)]="vehicletypeName">
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblVehicalType</span>
                      </ng-template>

                      <ng-option *ngFor="let item of vehicleTypeList" [value]="item.code">
                        <span class="w-66px">{{item.code}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{item.name}}</span>
                      </ng-option>
                    </ng-select>
                    <div *ngIf="cpf.vehicleTypeId.touched && cpf.vehicleTypeId.errors?.required"
                      class="help-block text-danger">
                      <em class="fa fa-exclamation-circle" aria-hidden="true"></em><span
                        translate>lblSelectVehicleType</span>
                    </div>
                  </div>
                </div>

                <div class="col-4 af-form-group">
                  <label class="text" for="name" translate>lblSequence
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <input formControlName="sequence" maxlength="10" class="form-control" pattern="^[0-9]{1,7}$"
                      placeholder="{{ 'lblSequenceNumber' | translate }}">
                    <div *ngIf="cpf.sequence.invalid && (cpf.sequence.dirty || cpf.sequence.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.sequence.errors.pattern"><span translate>lblProperValue</span>
                      </div>
                      <div *ngIf="cpf.sequence.errors.min" translate>
                        lblMinimumRequiredNumber
                      </div>
                      <div *ngIf="cpf.sequence.errors.max" translate>
                        lblMaximunRequiredNumber
                      </div>
                      <div *ngIf="cpf.sequence.errors.required" translate>
                        lblSequenceRequired
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-4" *ngIf="isShowCheckListType">
                  <label translate>lblChecklistType</label>
                  <input class="form-control mb-2" formControlName="colorcheckListType"
                    [ngModel]="cpf.colorcheckListType.value">

                </div>
                <div class="col-4 mt-4 pt-6">
                  <div *ngIf="checkListtypeValue == 2">
                    <em class="far fa-circle fa-lg text-info ml-3"></em>
                    <em class="far fa-circle fa-lg text-success ml-1"></em>
                  </div>
                  <div *ngIf="checkListtypeValue == 3">
                    <em class="far fa-circle fa-lg text-info ml-3"></em>
                    <em class="far fa-circle fa-lg text-success ml-1"></em>
                    <em class="far fa-circle fa-lg text-danger ml-1"></em>
                  </div>
                  <div *ngIf="checkListtypeValue == 4">
                    <em class="far fa-circle fa-lg text-info ml-3"></em>
                    <em class="far fa-circle fa-lg text-success ml-1"></em>
                    <em class="far fa-circle fa-lg text-danger ml-1"></em>
                    <em class="far fa-circle fa-lg text-warning ml-1"></em>
                  </div>
                </div>
                <div class="col-4"></div>

                <div class="w-100 col-12" *ngIf="t">
                  <div *ngFor="let ticket of t.controls; let i = index">
                    <div class="form-row" [formGroup]="ticket">
                      <div class="col-6 af-form-group">
                        <label for="name"><span translate>lblName</span><span>&nbsp;<span translate>lblIn</span>
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" maxlength="150">
                          <div *ngIf="ticket?.controls?.name?.touched && ticket?.controls?.name?.invalid" class="help-block mt-1 text-danger">
                            <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                              translate>lblCheckListNameRequired</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-6 af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                            maxlength="30">
                        </div>
                      </div>

                      <div class="col-6 af-form-group">
                        <label for="description"><span translate>lblDescription</span><span>&nbsp;<span
                              translate>lblIn</span>
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" maxlength="500">
                          <div *ngIf="ticket?.controls?.description?.touched && ticket?.controls?.description?.invalid" class="help-block mt-1 text-danger">
                            <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                              translate>lblCheckListDesRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4 af-form-group">
                  <div class='lbl-info'>
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblDisplayInDWO</label>
                    </div>
                  </div>
                </div>
                <div class="col-60 af-form-group"
                  *ngIf="(showPredefinedChecklist) && ((!condition)||(condition && cpf.isMulticolorCheckListSelected.value))">
                  <div class='lbl-info'>
                    <div class="custom-control custom-switch" [ngClass]="condition ? 'check-disabled' : null">
                      <input type="checkbox" class="custom-control-input" id="isMulticolorCheckListSelected"
                        formControlName="isMulticolorCheckListSelected" (click)="onShow()">
                      <label class="custom-control-label" for="isMulticolorCheckListSelected"
                        translate>lblIsMultiColorCheckList</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-100 " *ngIf="isMulticlr">
                  <input type="radio" id="2color" value="2" formControlName="twoColor" (change)="onChange($event)">
                  <label class="ml-2" for="2color" translate>lbl2Colour</label>
                  <em class="far fa-circle fa-lg text-info ml-3"></em>
                  <em class = "far fa-circle fa-lg text-success cursordisable ml-1"></em>

                </div>
                <div class="col-12 mt-15 " *ngIf="isMulticlr">
                   <input type="radio" id="3color" value="3" formControlName="twoColor" (change)="onChange($event)">
                   <label class="ml-2" for="3color" translate>lbl3Colour</label>
                   <em class="far fa-circle fa-lg text-info ml-3"></em>
                   <em class="far fa-circle fa-lg text-success ml-1"></em>
                   <em class="far fa-circle fa-lg text-danger cursordisable ml-1"></em>
                </div>  
                <div class="col-12 mt-15 " *ngIf="isMulticlr">
                    <input type="radio" id="4color" value="4" formControlName="twoColor" (change)="onChange($event)">
                    <label class="ml-2" for="4color" translate>lbl4Colour</label>
                    <em class="far fa-circle fa-lg text-info ml-3"></em>
                    <em class="far fa-circle fa-lg text-success ml-1"></em>
                    <em class="far fa-circle fa-lg text-danger cursordisable  ml-1"></em>
                    <em class="far fa-circle fa-lg text-warning ml-1"></em>
                </div>  
              </div>
            </div>

          </div>

        </div>

        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row mb15 align-items-center">
            <div class="col" *ngIf="isMulticlr">
              <em class="far fa-circle fa-lg text-info"><label class="ml-2" translate>lblNotChecked</label> </em>
              <em class="far fa-circle fa-lg text-success ml-3"><label class="ml-2" translate>lblChecked</label></em>
              <em class="far fa-circle fa-lg text-danger cursordisable ml-3"><label class="ml-2" translate>lblTobeFixed</label></em>
              <em class="far fa-circle fa-lg text-warning ml-3"><label class="ml-2" translate>lblNeedToBeFix</label></em>
              </div>
              <div class="col-9" *ngIf="!isMulticlr"></div>
            <div class="col-auto d-flex flex-sm-row flex-column justify-content-end">
              
              <button class="btn btn-primary btn-lg mr-sm-2" translate *ngIf="condition" [disabled]="addCheckListForm.valid ? isMulticlr ?  radioValue =='': isMulticlr :   !addCheckListForm.valid" 
                aria-label="Center Align">
                <em class="far fa-save font16 align-top mr-2"></em>
                lblSaveChanges</button>
                <button class="btn btn-primary btn-lg mr-sm-2" translate *ngIf="!condition" [disabled]="addCheckListForm.valid ? isMulticlr ?  radioValue =='': isMulticlr :   !addCheckListForm.valid" 
                aria-label="Center Align">
                <em class="fa fa-plus  font16 align-top mr-2"></em>
                lblAdd</button>
              <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>